<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.reset_password.fields.password.label')"
                    :placeholder="$t('forms.auth.reset_password.fields.password.placeholder')"
                    :isRequired="true"
                    type="password"
                    valuePath="password"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.reset_password.fields.password_confirm.label')"
                    :placeholder="$t('forms.auth.reset_password.fields.password_confirm.placeholder')"
                    :isRequired="true"
                    :error="passwordError"
                    type="password"
                    valuePath="passwordRepeat"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    :isProcessing="isLoading"
                    type="primary"
                    :label="$t('forms.auth.reset_password.buttons.reset_password')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import AuthAPI from 'api/AuthAPI'
    import FormMixin from 'mixins/FormMixin'
    import LoginType from 'enums/login_type.enum'
    import RoutesEnum from 'enums/routes.enum'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                passwordError: '',
            }
        },

        methods: {
            submit() {
                if (this.data.password !== this.data.passwordRepeat) {
                    this.passwordError = this.$t('forms.auth.reset_password.errors.passwords_not_match')
                    return
                }
                this.passwordError = ''
                this.submitForm(AuthAPI.resetPassword({ password: this.data.password, token: this.$route.query.token }))
                    .then((response) => {
                        const data = {
                            email: response.email,
                            password: this.data.password,
                        }
                        this.logUser(data)
                    })
                    .catch((err) => {
                        if (err.statusCode !== 422) {
                            this.emitEvent({ name: 'request-expired' })
                        }
                    })
            },

            logUser(data) {
                AuthAPI.login(data)
                    .then((res) => {
                        this.$auth.createSession({
                            accessToken: res.payload.access_token,
                            refreshToken: res.payload.refresh_token,
                            loginType: LoginType.BASIC,
                        })
                        this.$router.push({ name: RoutesEnum.INDEX.HOME })
                        this.$toast.success(this.$t('pages.auth.reset_password.notifications.password_changed'))
                    })
                    .catch((e) => {
                        this.emitEvent({
                            name: 'failure',
                            payload: {
                                errorMessage: e.error.message,
                                email: this.data.email,
                                callbackResendVerificationEmailFunction: this.resendVerificationEmail,
                            },
                        })
                    })
            },
        },
    }
</script>
